import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    errors: {
      email_busy: 'This email is already in use, Please, take another email.',
      wrong_json: 'json hasnt needed fields',
      short_password: 'password has less then 8 numbers',
      googleapi400: 'bad request to google api',
      bad_google_token: 'bad google token while google auth',
      no_username: 'authentification hasnt user',
      no_user: 'users email cant be found in db',
      google_user: 'user logged in only via google',
      purepurr_user: 'user already has password',
      wrong_password: ' Your current pasword is wrong, please try one more time.',
      glasses_status: 'These glasses are not available for activation. Please, check the number or contact administrator',
      glasses_busy: 'glasses alredy in use',
      no_glasses: 'glasses id cant be found in db',
      no_link: 'link cant be found in db',
      link_expired: 'link expired',
      invalid_auth_data: 'This user doesn\'t exist. Please, check your credentials',
      JWTDecodeException: 'cant decode link',
      AddressException: 'not valid email',
      MessagingException: 'error while sending email',
      JSONException: 'cant process string to json',
      SignatureVerificationException: 'cant check link singnature',
    },
    videoInfo: ''
  },
  mutations: {
    ADD_VIDEO(state, obj) {
      state.videoInfo = obj;
    }
  },
  actions: {
    addVideo({ commit }, obj) {
      commit("ADD_VIDEO", obj);
    }
  },
  getters: {
    getVideoInfo(state) {
      return state.videoInfo;
    },
    errorsList: state => {
      return state.errors
    }
  },
  modules: {}
});
